import React, { useCallback, useState } from "react";
import { FilterProps } from "@usereactify/search";
import { FilterChevron } from "./FilterChevron";

export type FilterRangeProps = React.ComponentProps<
  NonNullable<FilterProps["renderFilterRange"]>
>;

export const FilterRange: React.FC<FilterRangeProps> = (
  props
) => {
  const [open, setOpen] = useState(false)
  const toggleFilter = useCallback(() => setOpen(!open), [open])
  
  return (
    <div className={`rs__filter fade-in ${open && "open" || ""}`}>
      <div className="rs__filter-heading" onClick={toggleFilter}>
        <span>
          {props.filter.name}
        </span>

        <FilterChevron />
      </div>

      <ul className="rs__filter__list">
        {props.filterRangeProps.options.map((option) => (
          <li key={option.key} className="rs__filter__list-item">
            <label className="rs__filter__list-item-label">
              <input
                className="rs__filter__list-item-input"
                value={option.key}
                type="radio"
                checked={option.checked}
                onChange={(event) =>
                  props.filterRangeProps.handleChange(event.target.value)
                }
              />
              <span className="rs__filter__list-item-key">{option.label}</span>
            </label>
          </li>
        ))}
      </ul>
    </div>
  );
};
